export default "__VITE_ASSET__BtSUEdhW__"